import { OpenInNewIcon } from "@mgdx/ui/components/Icon";
import { cx } from "cva";
import React from "react";

import { ButtonLinkProps, variants } from ".";

export const ButtonExternalLink = ({
  className,
  disabled,
  children,
  variant,
  color,
  title,
  target = "_blank",
  rel = "noopener noreferrer",
  ...props
}: Readonly<ButtonLinkProps>) => (
  <a
    title={`${title}(別ウィンドウで開きます)`}
    aria-disabled={disabled}
    className={cx(className, variants({ variant, color }))}
    tabIndex={disabled ? -1 : undefined}
    target={target}
    rel={rel}
    {...props}
  >
    {children}
    <OpenInNewIcon />
  </a>
);
